<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.dialogs.code' |translate}}</mat-label>
      <input matInput type="text" [formControl]="codeControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.dialogs.title' |translate}}</mat-label>
      <input matInput type="text" [formControl]="titleControl" />
    </mat-form-field>


    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>

  </form>
</div>
